'use strict';

// @ts-ignore
exports.__esModule = true;
// @ts-ignore
exports.default = {
  el: {
    colorpicker: {
      confirm: 'OK',
      clear: 'O\'chirish'
    },
    datepicker: {
      now: 'Hozir',
      today: 'Bugun',
      cancel: 'Bekor qilish',
      clear: 'O\'chirish',
      confirm: 'OK',
      selectDate: 'Sanani tanlash',
      selectTime: 'Vaqtni tanlash',
      startDate: 'Boshlaninsh sanasi',
      startTime: 'Boshlanish vaqti',
      endDate: 'Tugash kuni',
      endTime: 'Tugash vaqti',
      prevYear: 'Oldingi yil',
      nextYear: 'Keyingi yil',
      prevMonth: 'Oldingi oy',
      nextMonth: 'Keyingi oy',
      year: '',
      month1: 'Yanvar',
      month2: 'Fevral',
      month3: 'Mart',
      month4: 'Aprel',
      month5: 'May',
      month6: 'Iyun',
      month7: 'Iyul',
      month8: 'Avgust',
      month9: 'Sentyabr',
      month10: 'Oktyabr',
      month11: 'Noyabr',
      month12: 'Dekabr',
      // week: 'week',
      weeks: {
        sun: 'Yak',
        mon: 'Du',
        tue: 'Se',
        wed: 'Chor',
        thu: 'Pay',
        fri: 'Ju',
        sat: 'Shan'
      },
      months: {
        jan: 'Yan',
        feb: 'Fev',
        mar: 'Mart',
        apr: 'Apr',
        may: 'May',
        jun: 'Iyun',
        jul: 'Iyul',
        aug: 'Avg',
        sep: 'Sen',
        oct: 'Оkt',
        nov: 'Noy',
        dec: 'Dek'
      }
    },
    select: {
      loading: 'Yuklanmoqda',
      noMatch: 'Hech qanday moslik topilmadi',
      noData: 'Ma\'lumot yo\'q',
      placeholder: 'Tanlash'
    },
    cascader: {
      noMatch: 'Hech qanday moslik topilmadi',
      loading: 'Yuklanmoqda',
      placeholder: 'Tanlash'
    },
    pagination: {
      goto: 'O\'tish',
      pagesize: ' sahifada',
      total: 'Jami {total}',
      pageClassifier: ''
    },
    messagebox: {
      title: 'Xabar',
      confirm: 'OK',
      cancel: 'Bekor qilish',
      error: 'Noto\'g\'ri kiritildi'
    },
    upload: {
      deleteTip: 'O\'chirish uchun [O\'chirish] tugmasini bosing',
      delete: 'O\'chirish',
      preview: 'Oldindan ko\'rish',
      continue: 'Davom ettirish'
    },
    table: {
      emptyText: 'Hech qanday ma\'lumot yo\'q',
      confirmFilter: 'Tasdiqlash',
      resetFilter: 'Qayta tiklash',
      clearFilter: 'Hammasi',
      sumText: 'Summa'
    },
    tree: {
      emptyText: 'Hech qanday ma\'lumot yo\'q'
    },
    transfer: {
      noMatch: 'Hech qanday moslik topilmadi',
      noData: 'Hech qanday ma\'lumot yo\'q',
      titles: ['Ro\'yxat  1', 'Ro\'yxat  2'],
      filterPlaceholder: 'Kalit so\'zni kiriting',
      noCheckedFormat: '{total} punktlar',
      hasCheckedFormat: '{checked}/{total} tanlandi'
    }
  }
};